<template>
  <div id="app">
    <keep-alive include="glzy,jgqk">
      <router-view />
    </keep-alive>
    <!--iframe页-->
    <component
      v-for="item in hasOpenComponentsArr"
      :key="item.name"
      :is="item.name"
      v-show="$route.name === item.name"
    ></component>
  </div>
</template>

<script>
// import Vue from "vue";
export default {
  components: {
    jgqk: resolve => require(["@/views/jgqk"], resolve),
    glzy: resolve => require(["@/views/glzy"], resolve)
  },
  computed: {
    // 实现懒加载，只渲染已经打开过（hasOpen:true）的iframe页
    hasOpenComponentsArr() {
      return this.componentsArr.filter(item => {
        return item.hasOpen;
      });
    }
  },
  data() {
    return {
      componentsArr: []
    };
  },
  watch: {
    $route() {
      // 判断当前路由是否iframe页
      this.isOpenIframePage();
    }
  },
  created() {
    // 设置iframe页的数组对象
    const componentsArr = this.getComponentsArr();
    // componentsArr.forEach(item => {
    //   Vue.component(item.name, item.component);
    // });
    this.componentsArr = componentsArr;
    // 判断当前路由是否iframe页
    this.isOpenIframePage();
  },
  methods: {
    // 根据当前路由设置hasOpen
    isOpenIframePage() {
      const target = this.componentsArr.find(item => {
        return item.name === this.$route.name;
      });
      if (target && !target.hasOpen) {
        target.hasOpen = true;
        console.log("set", target.name, "to open");
      }
    },
    // 遍历路由的所有页面，把含有iframeComponent标识的收集起来
    getComponentsArr() {
      return [
        {
          path: "/jgqk",
          name: "jgqk",
          hasOpen: false,
          component: "jgqk"
        },
        {
          path: "/glzy",
          name: "glzy",
          hasOpen: false,
          component: "glzy"
        }
      ];
      /* const router = this.$router;
      const routes = router.options.routes;
      const iframeArr = [];
      const singleRoutes = routes[6];
      const printReportObj = {
        name: routes[6].children[0].name,
        path: routes[6].children[0].path,
        hasOpen: false, // 是否打开过，默认false
        component: routes[6].children[0].iframeComponent // 组件文件的引用
      };
      singleRoutes.children.splice(0, 1);
      singleRoutes.children.push(printReportObj);
      iframeArr.push(singleRoutes);
      return iframeArr; */
    }
  }
};
</script>

<style lang="stylus">
@import '~@/assets/styl/index.styl'

.ifr-dialog
  height 100vh
  background transparent
  .el-dialog__headerbtn .el-dialog__close
    color white
    font-size 40px
  .el-dialog__header,.el-dialog__body
    padding 0
  .iframe
    width 100%
    height 100vh

#app
  font-family 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  position fixed
  width 100%
  height 100%
  .flex-box
    display flex
    align-items center
    justify-content center
  :focus
    outline none
</style>
